exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container {\n  margin: 20px 0 0 20px;\n  cursor: pointer; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/alocar-recipiente-dialog/alocar-recipiente-dialog.component.scss
// module id = ../../../../../src/app/alocar-recipiente-dialog/alocar-recipiente-dialog.component.scss
// module chunks = main